import { render, staticRenderFns } from "./movements-events-combined-table.vue?vue&type=template&id=2b636d19&"
import script from "./movements-events-combined-table.vue?vue&type=script&lang=js&"
export * from "./movements-events-combined-table.vue?vue&type=script&lang=js&"
import style0 from "./movements-events-combined-table.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b636d19')) {
      api.createRecord('2b636d19', component.options)
    } else {
      api.reload('2b636d19', component.options)
    }
    module.hot.accept("./movements-events-combined-table.vue?vue&type=template&id=2b636d19&", function () {
      api.rerender('2b636d19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/movements-events-combined-table/movements-events-combined-table.vue"
export default component.exports